<template>
    <a class="relative block overflow-hidden group bg-blue-600" :href="page.roam_products_url">
        <img
            class="object-cover object-center w-full h-full max-h-full group-hover:opacity-0 lazyload"
            :data-srcset="image"
            data-sizes="(min-width: 1024px) 290px, 100vw"
            :alt="page.title"
            width="328"
            height="400"
        />

        <div class="absolute inset-0 transition-opacity duration-150 transform bg-gradient-dark">
            <div
                class="flex flex-col justify-end items-center h-full p-8 transition-transform duration-150 transform translate-y-20 group-hover:translate-y-0"
            >
                <div class="text-center">
                    <h3 class="h4 text-white">{{ page.title }}</h3>

                    <a
                        class="btn btn-primary mt-8 transition-all duration-500 opacity-0 group-hover:opacity-100"
                    >
                        View
                    </a>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import { truncate } from 'lodash';

export default {
    props: {
        page: {
            type: Object,
            required: true
        }
    },

    computed: {
        image() {
            if (this.page.roam_common_pageHeader_image.length) {
                return (
                    this.page.roam_common_pageHeader_image &&
                    this.page.roam_common_pageHeader_image.join(', ')
                );
            } else {
                return 'https://assets.australiascoralcoast.com/images/Francois-Peron-National-Park-1.jpg?auto=compress&fit=clip&fm=webp&q=80&ratio=16%3A9&&w=640';
            }
        }
    },

    methods: {
        trunc(string) {
            return truncate(string, { length: 100, seperator: '&hellip;' });
        }
    }
};
</script>
